/**
 * Who we are, as the legal pages name it. Fill these in once the operating company is settled
 * (ADR 0002); while `draft` is true every legal page carries a draft notice.
 */
export const LEGAL = {
  company: "[Company legal name]",
  address: "[Business address]",
  supportEmail: "support@websede.com",
  privacyEmail: "privacy@websede.com",
  abuseEmail: "abuse@websede.com",
  governingState: "Texas",
  effectiveDate: "[Effective date]",
  /** Production hosting is chosen with the production environment. */
  hostingProvider: "[Hosting provider]",
  draft: true,
} as const;

/** Replaces {{key}} in a legal document with the values above. */
export function fillLegal(markdown: string): string {
  return markdown.replace(/\{\{(\w+)\}\}/g, (match, key: string) => {
    const value = (LEGAL as Record<string, unknown>)[key];
    return typeof value === "string" ? value : match;
  });
}
